import { interpretUserNameError } from "../../validators/interpretators"
import { validators } from "../../validators/validators"

export const validateEmail = (email) => {
    let err = validators.ValidateEmail(email)
    if (err != null) {
        return "errors.email.invalid_format"
    }
    return null
}

export const validateUserName = (name) => {
    let err = validators.ValidateUserName(name)
    if (err != null) {
        return interpretUserNameError (
            validators.ValidateUserName(name)
        )
    }
    return null
}